const DynamicForm = require("app/components/forms/DynamicForm");
const router = require("app/services/router");
const PropTypes = require("prop-types");
const PhoneField = require("app/components/fields/Phone");
const ZipField = require("app/components/fields/ZipCity");
const assign = require("object-assign");

class Profile extends DynamicForm {

	static get propTypes() {
		return assign({}, super.propTypes, {
			id: PropTypes.number.isRequired,
			name: PropTypes.string,
			phone: PropTypes.string,
			company: PropTypes.string,
			address: PropTypes.string,
			zipCode: PropTypes.string,
			city: PropTypes.string,
			email: PropTypes.string
		});
	}

	static get defaultProps() {
		return {
			performValidationOnLoad: true
		};
	}

	constructor(props) {
		super(props);

		this.state = assign(this.state, {
			password: "",
			passwordConfirmation: ""
		});
	}

	get actionUrl() {
		return router.route("api.users.update", {user_id: this.props.id});
	}

	get validationUrl() {
		return router.route("api.users.validate", {user_id: this.props.id});
	}

	buildPayload(form) {
		let payload = super.buildPayload(form);

		if ((payload.get("password").length === 0) && (payload.get("password_confirmation").length === 0)) {
			payload.delete("password");
			payload.delete("password_confirmation");
		}

		return payload;
    }

  onComplete(response) {
    // Empty passwords
    this.bodyElement.querySelectorAll("input[type=password]").forEach(input => {
      input.value = "";
    });

    super.onComplete(response);
  }

  isValid(name) {
    if (name === "password_confirmation") {
      return this.state.password === this.state.passwordConfirmation;
    }

    return super.isValid(name);
  }

  onPasswordChange = (e) => {
    this.setState({password: e.target.value});
    this.onChange("password")();
  };

  onPasswordConfirmationChange = (e) => {
    this.setState({passwordConfirmation: e.target.value});
    this.onChange("password")();
    this.onChange("password_confirmation")();
  };


  renderPasswordValidity() {
    if ((this.state.password.length > 0) || (this.state.passwordConfirmation.length > 0)) {
      return this.renderValidity("password");
    }
  }

  renderPasswordConfirmationValidity() {
		if ((this.state.password.length > 0) || (this.state.passwordConfirmation.length > 0)) {
			return this.renderValidity("password_confirmation");
		}
	}

	renderForm() {
		return (
			<form onSubmit={this.onSubmit}>
				<h2>Dine oplysninger</h2>
				<p>Udfyld og Bekræft at dine oplysninger er korrekte.</p>
				<div className="inputs">

					<div className="field required">
						<label htmlFor="profileNameInput">Navn</label>
						{this.renderValidity("name")}
						<input defaultValue={this.props.name} type="text" id="profileNameInput" name="name" required={true}
									 onInput={this.onChange("name")}/>
						{this.renderError("name")}
					</div>

					<div className="field required">
						<label htmlFor="profilePhoneInput">Telefon nr</label>
						{this.renderValidity("phone")}
						<PhoneField defaultValue={this.props.phone} id="profilePhoneInput" name="phone" required={true}
												onInput={this.onChange("phone")}/>
						{this.renderError("phone")}
					</div>

					<div className="field">
						<label htmlFor="profileCompanyInput">Firma</label>
						{this.renderValidity("company")}
						<input defaultValue={this.props.company} type="text" id="profileCompanyInput" name="company"
									 onInput={this.onChange("company")}/>
						{this.renderError("company")}
					</div>

					<div className="field required">
						<label htmlFor="profileAddressInput">Adresse</label>
						{this.renderValidity("address")}
						<input defaultValue={this.props.address} type="text" id="profileAddressInput" name="address" required={true}
									 onInput={this.onChange("address")}/>
						{this.renderError("address")}
					</div>

					<div className="field required">
						<label htmlFor="profileZipCodeInput">Postnr</label>
						{this.renderValidity("zipCode")}
						<ZipField id="profileZipCodeInput" name="zipCode" zip={this.props.zipCode} city={this.props.city}
											zipPlaceholder="" cityPlaceholer=""
											onChange={this.onChange("zipCode")}/>
						{this.renderError("zipCode")}
					</div>

					<div className="field required">
						<label htmlFor="profileEmailInput">Email</label>
						{this.renderValidity("email")}
						<input defaultValue={this.props.email} type="email" id="profileEmailInput" name="email" required={true}
									 onInput={this.onChange("email")}/>
						{this.renderError("email")}
					</div>

				</div>

				<h2>Ændring af adgangskode</h2>
				<p>Udfyld og Bekræft at dine oplysninger er korrekte.</p>

				<div className="inputs">

					<div className="field">
						<label htmlFor="profilePasswordInput">Ny adgangskode</label>
						{this.renderPasswordValidity()}
						<input type="password" id="profilePasswordInput" name="password" defaultValue={this.state.password}
									 onInput={this.onPasswordChange}/>
						{this.renderError("password")}
					</div>

					<div className="field">
						<label htmlFor="profilePasswordConfirmationInput">Ny adgangskode</label>
						{this.renderPasswordConfirmationValidity()}
						<input type="password" id="profilePasswordConfirmationInput" name="password_confirmation"
									 defaultValue={this.state.passwordConfirmation}
									 onInput={this.onPasswordConfirmationChange}/>
					</div>

				</div>

				<div className="button leftalign">
					<div className="submit-container">
						<input type="submit" value="Gem"/>
					</div>
					{this.renderMessage()}
				</div>
			</form>
		);
	}

}

module.exports = Profile;
